module.exports = __webpack_public_path__ + "static/media/tissuesDisposables.44c2a45b.webp";